module.exports = __webpack_public_path__ + "static/img/phone_ico_logo.9f17345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone_ico_logo.png
// module id = Bjjv
// module chunks = 0